"use client";

import { useRouter } from "next/navigation";

import { API_BASE_URL } from "@/lib/api-base";
import { isUsableWebSession, useAuthStore } from "@/lib/auth-store";

/**
 * CTA button for sponsored feed cards (FEAT-AGRIBUSINESS-001). Fires a
 * best-effort click beacon to the public campaign-delivery endpoint, then
 * routes the visitor into sign-in so the inquiry continues in chat.
 */
export function SponsoredCta({
  campaignId,
  label,
  clickToken,
}: {
  campaignId: string;
  label: string;
  clickToken?: string;
}) {
  const router = useRouter();
  const user = useAuthStore((state) => state.user);
  const accessToken = useAuthStore((state) => state.accessToken);
  const demoMode = useAuthStore((state) => state.demoMode);
  const hasSession = isUsableWebSession({ user, accessToken, demoMode });

  const handleClick = () => {
    if (campaignId) {
      void fetch(`${API_BASE_URL}/campaign-delivery/campaigns/${campaignId}/click`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
        body: JSON.stringify({
          surface: accessToken ? "web_authenticated_feed" : "web_public_feed",
          clickToken,
        }),
        keepalive: true,
      }).catch(() => undefined);
    }
    router.push(hasSession ? "/messages" : "/auth?next=/");
  };

  return (
    <button type="button" className="link-pill" onClick={handleClick}>
      {label}
    </button>
  );
}
